import { LoadingLayout } from 'components';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import {
  getLegalRepresentativeMainInfo,
  getLegalRepresentativeRepresentativeType,
} from '../helpers';
import { useLegalClientRepresentative } from '../hooks';
import { LegalRepresentativeView } from '../views';

export type LegalRepresentativeContainerParams = {
  legalClientRepresentativeId: string;
};

export const LegalRepresentativeContainer = () => {
  const {
    legalClientRepresentative,
    loading,
    countries,
    countriesLoading,
    error,
    initialValues,
    submitLoading,
    breadcrumbsTitles,
    revokeOtpVerificationLoading,
    lockClientIfPossible,
    unlockClient,
    onSubmit,
    onChangeClientType,
    onShowVersionHistory,
    onRevokeOtpVerification,
    onSendInvitationToAccount,
  } = useLegalClientRepresentative();

  if (error || (!legalClientRepresentative && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !legalClientRepresentative) {
    return <LoadingLayout />;
  }

  const mainInfo = getLegalRepresentativeMainInfo(legalClientRepresentative);
  const representativeType = getLegalRepresentativeRepresentativeType(
    legalClientRepresentative
  );

  return (
    <LegalRepresentativeView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      kycData={legalClientRepresentative.kyc}
      lockClientIfPossible={lockClientIfPossible}
      mainInfo={mainInfo}
      representativeType={representativeType}
      revokeOtpVerificationLoading={revokeOtpVerificationLoading}
      submitLoading={submitLoading}
      unlockClient={unlockClient}
      onChangeClientType={onChangeClientType}
      onRevokeOtpVerification={onRevokeOtpVerification}
      onSendInvitationToAccount={onSendInvitationToAccount}
      onShowVersionHistory={onShowVersionHistory}
      onSubmit={onSubmit}
    />
  );
};
